import { DELETE_ROLEMAP, UPDATE_ROLEMAP } from '../../constant';

const updateRoleMapAction = (roleList, wardId, isLogin) => ({
  type: UPDATE_ROLEMAP,
  data: roleList,
  wardId: wardId,
  isLogin: isLogin,
});

const deleteRoleMapAction = () => ({
  type: DELETE_ROLEMAP,
});

export { updateRoleMapAction, deleteRoleMapAction };
